import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { ZendeskApiError } from '../models/zendesk-api-response';
import { Request, FileUploadResponse } from '../models/request';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ZendeskArticleSearchResult, ZendeskPageSearchResult } from '../models/zendesk-search-result';
import { LanguageService } from './language.service';
import { ZendeskAttachmentsResult } from '../models/zendesk-attachments-result';

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {

  baseAPIUrl: string = environment.zendeskAPIUrl;

  endpoint: string;

  constructor(
    private http: HttpClient,
    public language: LanguageService
  ) {
    this.endpoint = 'requests';
  }

  getAPIUrl(endpoint: string) {
    return `${this.baseAPIUrl}/${endpoint}`;
  }

  public createRequest(request: Request): Observable<Request | ZendeskApiError> {
    let url = `${environment.metAPIUrl}/portals/zendesk`;
    return this.http.post<Request>(url, { request: request })
      .pipe(map(unit => <Request>unit),
      catchError(error => this.handleError(error)));
  }

  public uploadFile(file: File): Observable<FileUploadResponse | ZendeskApiError> {
    const url = this.getAPIUrl('uploads.json?filename=' + file.name);
    return this.http.post<FileUploadResponse>(url, file)
      .pipe(map(unit => <FileUploadResponse>unit),
      catchError(error => this.handleError(error)));
  }

  private handleError(res: HttpErrorResponse | any) {
    let error = <ZendeskApiError>res.error;
    return throwError(error);
  }

  public search(query: string): Observable<ZendeskPageSearchResult | ZendeskApiError> {
    const lang = this.language.getLang();
    let locale = 'en-us';
    if (lang === 'it') {
      locale = 'it';
    }
    const url = this.getAPIUrl('help_center/articles/search.json?query=' + query + '&locale=' + locale + '&per_page=100');
    return this.http.get<ZendeskPageSearchResult>(url)
      .pipe(map(unit => <ZendeskPageSearchResult>unit),
      catchError(error => this.handleError(error)));
  }

  public getArticle(id: string): Observable<ZendeskArticleSearchResult | ZendeskApiError> {
    const lang = this.language.getLang();
    let locale = 'en-us';
    if (lang === 'it') {
      locale = 'it';
    }
    const url = this.getAPIUrl('help_center/' + locale + '/articles/' + id);
    return this.http.get<ZendeskArticleSearchResult>(url)
      .pipe(map(unit => <ZendeskArticleSearchResult>unit),
      catchError(error => this.handleError(error)));
  }

  public getArticleAttachments(id: string): Observable<ZendeskAttachmentsResult | ZendeskApiError> {
    const url = this.getAPIUrl('help_center/articles/' + id + '/attachments.json');
    return this.http.get<ZendeskAttachmentsResult>(url)
      .pipe(map(unit => <ZendeskAttachmentsResult>unit),
      catchError(error => this.handleError(error)));
  }
}
